var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "jzx1sete4a",
    cx: 8,
    cy: 8,
    r: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cefjdnyceb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jzx1sete4a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#477AFE",
    xlinkHref: "#jzx1sete4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.218 12.526a.227.227 0 0 0-.192.128.246.246 0 0 0 .01.237.224.224 0 0 0 .203.109h9.53a.225.225 0 0 0 .2-.118.246.246 0 0 0 0-.239.225.225 0 0 0-.2-.117H3.219z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.64,
    mask: "url(#cefjdnyceb)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cefjdnyceb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 -19.58 10.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.264.956.692.007L2.2 2.68l6.714.24c1.234.048 2.2.09 2.399.11.634.065 1.402.57 1.657.727.28.174.206.641-.526.747l-.206.026c-.618.067-1.79.116-3.568-.019L5.398 6.275l-.59-.22-.138-.602.27.075.168.174 1.385-1.417-.232-.03-1.481-.21C2.29 3.679.792 3.387.792 3.387L.264.956zm3.4-.78.192.087.263.55 3.19 1.83-1.958-.072-1.588-1.54-.1-.855z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.97 4.57h.817v-.204l-.816.021z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M10.379 4.569v.254"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 10.398,
    cy: 4.886,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrival);
export default __webpack_public_path__ + "static/media/icon-arrival.bd4cf70f86095dd917593b8806ad2b2c.svg";
export { ForwardRef as ReactComponent };